/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AddLabelsToCompany
 */
export interface AddLabelsToCompany {
  /**
   *
   * @type {string}
   * @memberof AddLabelsToCompany
   */
  companyId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof AddLabelsToCompany
   */
  companyLabelIds: Array<string>;
}

/**
 * Check if a given object implements the AddLabelsToCompany interface.
 */
export function instanceOfAddLabelsToCompany(
  value: object,
): value is AddLabelsToCompany {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("companyLabelIds" in value) || value["companyLabelIds"] === undefined)
    return false;
  return true;
}

export function AddLabelsToCompanyFromJSON(json: any): AddLabelsToCompany {
  return AddLabelsToCompanyFromJSONTyped(json, false);
}

export function AddLabelsToCompanyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AddLabelsToCompany {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    companyLabelIds: json["companyLabelIds"],
  };
}

export function AddLabelsToCompanyToJSON(json: any): AddLabelsToCompany {
  return AddLabelsToCompanyToJSONTyped(json, false);
}

export function AddLabelsToCompanyToJSONTyped(
  value?: AddLabelsToCompany | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    companyLabelIds: value["companyLabelIds"],
  };
}
